module.exports = __webpack_public_path__ + "static/img/wood82.1e74a20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood82.jpg
// module id = qBcW
// module chunks = 0